<template>
  <div v-if="esVendedora" class="estatus-recepcion-sidebar px-2 pb-2">
    <v-select
      v-model="estatusLocal"
      :items="opciones"
      item-text="label"
      item-value="value"
      dense
      filled
      hide-details
      label="Estatus recepción"
      class="estatus-recepcion-sidebar__select"
      :loading="guardando"
      :disabled="guardando"
      @change="guardarEstatus"
    >
      <template v-slot:item="{ item }">
        <v-list-item-avatar size="20" class="my-1 mr-2">
          <v-avatar :color="item.color" size="12" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-caption">{{ item.label }}</v-list-item-title>
        </v-list-item-content>
      </template>
      <template v-slot:selection="{ item }">
        <span class="estatus-recepcion-sidebar__sel">
          <v-avatar :color="item.color" size="10" class="mr-2" />
          {{ item.label }}
        </span>
      </template>
    </v-select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import validarErrores from '@/mixins/validarErrores';
import {
  OPCIONES_ESTATUS_VENDEDORA,
  esVendedoraRanking,
} from '@/utils/estatusVendedoraRanking';

export default {
  name: 'EstatusRecepcionSidebar',

  mixins: [validarErrores],

  data: () => ({
    opciones: OPCIONES_ESTATUS_VENDEDORA,
    estatusLocal: 'Disponible',
    guardando: false,
  }),

  computed: {
    ...mapGetters('login', [
      'getdatosUsuarioERPERP',
      'getEstatusRecepcionVersion',
    ]),

    esVendedora() {
      const u = this.getdatosUsuarioERPERP;
      return u && esVendedoraRanking(u.idpuesto);
    },

    miId() {
      const u = this.getdatosUsuarioERPERP;
      return u && u.iderp != null ? Number(u.iderp) : null;
    },
  },

  watch: {
    getEstatusRecepcionVersion() {
      this.syncDesdeStore();
    },

    miId: {
      immediate: true,
      handler() {
        this.syncDesdeStore();
      },
    },
  },

  async mounted() {
    if (this.esVendedora) {
      await this.cargarEstatusRecepcionMap();
      this.syncDesdeStore();
    }
  },

  methods: {
    ...mapActions('login', ['cargarEstatusRecepcionMap', 'actualizarMiEstatusRecepcion']),

    syncDesdeStore() {
      if (this.miId == null) return;
      const est = this.$store.getters['login/estatusRecepcionDeUsuario'](this.miId);
      this.estatusLocal = est;
    },

    async guardarEstatus(estatus) {
      if (!estatus || this.miId == null) return;
      this.guardando = true;
      try {
        await this.actualizarMiEstatusRecepcion(estatus);
      } catch (error) {
        const msg = (error.response && error.response.data && error.response.data.message)
          || error.message
          || 'No se pudo guardar el estatus';
        this.validarError(msg);
      } finally {
        this.guardando = false;
        this.syncDesdeStore();
      }
    },
  },
};
</script>

<style scoped>
.estatus-recepcion-sidebar__select {
  font-size: 0.78rem;
}

.estatus-recepcion-sidebar__select >>> .v-label {
  font-size: 0.72rem;
}

.estatus-recepcion-sidebar__sel {
  display: inline-flex;
  align-items: center;
  font-size: 0.78rem;
  font-weight: 600;
}
</style>
